<template>
    <PageHeader>
        {{ $t('producerPlugin.title') }}
        <template #subtitle>
            {{ $t('producerPlugin.description') }}

            <p class="font-weight-semibold mt-3">
                {{ $t('pluginCode.pluginId') }}:
                <span class="ml-2 text-monospace">{{ pluginId }}</span>
            </p>
        </template>
        <template #bottom>
            <div class="d-flex gap-3">
                <ButtonIcon
                    icon="file-text"
                    :icon-size="24"
                    href="https://help.100shoppers.com/en/articles/4726202-plugin-implementation"
                    target="_blank"
                    variant="link"
                    class="p-0"
                >
                    {{ $t('seeHowToImplementPlugin') }}
                </ButtonIcon>
            </div>
        </template>
    </PageHeader>
</template>

<script>
    export default {
        name: 'PluginCode',
        props: {
            plugin: {
                type: Object,
                required: true,
            },
        },
        computed: {
            pluginId() {
                return this.plugin.id;
            },
        },
    };
</script>

<style scoped>
    .text-monospace {
        font-family: monospace;
    }
</style>
